<template>
  <v-container class="userdata-container">
    <v-row class="firstrow">
      <v-col cols="12" sm="4" class="first-col">
        <div class="maintitle">{{ $t("Support.reference_data") }}</div>
        <div class="text">
          <div>
            <span>{{ $t("Support.name") }}</span
            ><span>{{ reference_data.name }}</span>
          </div>
          <div>
            <span>{{ $t("Support.surname") }}</span
            ><span>{{ reference_data.surname }}</span>
          </div>
          <div>
            <span>{{ $t("Support.email") }}</span
            ><span :title="reference_data.fullEmail">{{
              reference_data.email
            }}</span>
          </div>
          <div class="bar-div"></div>
        </div>
      </v-col>
      <v-col cols="12" sm="3" class="company-col">
        <div class="maintitle">{{ $t("Support.company_data") }}</div>
        <div class="text">
          <div v-if="!isSupport">
            <span>{{ $t("Support.code") }}</span
            ><span>{{ company_data.altkn }}</span>
          </div>
          <div>
            <span>{{ $t("Support.company_name") }}</span
            ><span>{{ company_data.name }}</span>
          </div>
          <div v-if="isSupport">
            <span>{{ $t("Support.street") }}</span
            ><span>{{ company_data.street }}</span>
          </div>
          <div v-if="isSupport">
            <span>{{ $t("Support.zipcode") }}</span
            ><span>{{ company_data.zipcode }}</span>
          </div>
          <div v-if="isSupport">
            <span>{{ $t("Support.locality") }}</span
            ><span>{{ company_data.locality }}</span>
          </div>
          <div class="support-nation-div" v-if="isSupport">
            <span>{{ $t("Support.nation") }}</span
            ><span>{{ company_data.nation }}</span>
          </div>
          <div class="support-phone-div" v-if="isSupport">
            <span>{{ $t("Support.phone") }}</span
            ><span>{{ company_data.phone }}</span>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="5" class="nation-col" v-if="isSupport">
        <div class="no-title"></div>
        <div class="text">
          <div class="nation-div">
            <span>{{ $t("Support.nation") }}</span
            ><span>{{ company_data.nation }}</span>
          </div>
          <div>
            <span>{{ $t("Support.phone") }}</span
            ><span>{{ company_data.phone }}</span>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
.userdata-container {
  height: 100%;
}

.userdata-container .first-col {
  padding-left: 57px;
}

.userdata-container .no-title {
  margin-top: 92px;
}

.userdata-container .support-nation-div,
.userdata-container .support-phone-div {
  display: none;
}

.userdata-container .maintitle,
.no-commercial-box-container .maintitle {
  color: #707070;
  margin-bottom: 6px;
  margin-top: 0px !important;
  font: normal normal bold 30px/35px Roboto;
}

.userdata-container .text,
.no-commercial-box-container .text {
  letter-spacing: 0px;
  color: #707070;
  font: normal normal bold 20px/24px Lato;
}

.userdata-container .text div,
.no-commercial-box-container .text div {
  padding-top: 18px;
}

.userdata-container .text span,
.no-commercial-box-container .text span {
  margin-right: 14px;
}

.userdata-container .firstrow {
  padding: 32px 0 40px 0;
  height: 100%;
}

.userdata-container .bar-div {
  display: none;
}
.userdata-container,
.no-commercial-box-container {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 10px 10px 15px #6f767ab3;
  border-radius: 40px;
  padding: 0;
}

@media (max-width: 600px) {
  .profile-main .container {
    max-width: 100% !important;
    height: 550px;
  }

  .container {
    margin: 0px;
  }

  .userdata-container {
    padding-bottom: 40px;
    border-radius: 20px !important;
  }

  .userdata-container .company-col {
    border: none;
  }

  .userdata-container .firstrow {
    padding: 20px 0 40px 0;
  }

  .userdata-container .firstrow {
    margin: 12px 0 12px 0;
  }
  .userdata-container .bar-div {
    display: block;
  }

  .userdata-container .text {
    font: normal normal bold 15px/18px Lato;
  }

  .userdata-container .no-title {
    margin-top: 0px;
  }

  .userdata-container .first-col {
    padding-left: 16px;
  }

  .userdata-container {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 10px 10px 15px #6f767ab3;
    border-radius: 40px;
    padding: 0;
  }
}

.userdata-container .maintitle {
  font: normal normal bold 20px/24px Roboto;
}

.userdata-container .company-col {
  padding-bottom: 18px;
  /* padding-top: 0px; */
  padding-left: 16px;
}

.userdata-container .nation-div {
  padding-top: 0px !important;
}

/* .userdata-container .company-col .text {
  padding-top: 20px;
} */

.userdata-container .nation-col {
  padding: 0 0 0 16px;
}

.userdata-container .bar-div {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-bottom: 2px solid;
  width: 340px;
}
</style>
<script>
import { Trans } from "@/plugins/Translation";
import MDApi from "../api/MD/MDApi.js";

export default {
  props: {
    item: {
      title: String,
      img_name: String,
      color: String,
      description: String,
    },
    isSupport: {
      default: true,
      type: Boolean,
    },
  },

  data() {
    return {
      isMobile: false,
      user: null,
      reference_data: {
        name: "",
        surname: "",
        email: "",
        fullEmail: "",
      },
      company_data: {
        name: "",
        street: "",
        zipcode: "",
        locality: "",
        nation: "",
        phone: "",
        altkn: "",
      },
    };
  },

  created() {
    window.addEventListener("resize", this.myEventHandler);
    this.setIsMobile();

    this.user = this.$GAUserAuth.user;
    this.reference_data.fullEmail = this.user.username;
    this.reference_data.name = this.user.firstname;
    this.reference_data.surname = this.user.lastname;
    this.reference_data.email = this.$genericClass.TruncateString(
      this.user.username,
      true
    );

    let companyCode = this.user.companyCode;

    MDApi.GetCompanyData(companyCode).then((res) => {
      if (res.data) {
        this.company_data.name = res.data.Name;
        this.company_data.street = res.data.Address;
        this.company_data.zipcode = res.data.ZipCode;
        this.company_data.locality = res.data.City;
        this.company_data.nation = res.data.CountryDescription;
        this.company_data.phone = res.data.AccountingPhone;
        this.company_data.altkn = res.data.AltKN;
      }
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },

  methods: {
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
  },
};
</script>